import { render, staticRenderFns } from "./StaticInvoiceTable.vue?vue&type=template&id=387343ef&"
import script from "./StaticInvoiceTable.vue?vue&type=script&lang=js&"
export * from "./StaticInvoiceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StaticInvoiceTable.vue"
export default component.exports